import { Injectable } from '@angular/core';

interface RuntimeConfig {
  apiBase: string;
}

declare global {
  interface Window {
    __wba_config__?: RuntimeConfig;
  }
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly config: RuntimeConfig;

  constructor() {
    // Read from window.__wba_config__ injected by index.html.
    // Edit index.html post-deployment to change values without rebuilding.
    this.config = window.__wba_config__ ?? { apiBase: '/api' };
  }

  get apiBase(): string {
    return this.config.apiBase;
  }
}
